export class User {
  token: string;
  token_type: string;
  expires_in: number;
  trade_program: any;
  impersonate?: boolean;
  data: {
    token?: string;
    id?: number;
    role_id?: number;
    role?: number;
    phone?: string;
    name: string;
    email: string;
    route_permissions?: string[];
    company?: {
      logo?: any;
      name?: string;
    };
    avatar: {
      id: number;
      url: string;
    };
  };
}
